import React from 'react'
import PageForm from '../form'

const PrivacyPolicy = () => {
  return (
    <>
      <PageForm title="Privacy Policy" Key="privacy-policy" />
    </>
  )
}

export default PrivacyPolicy
